// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"fb4324ec","161":"d845b8b8","262":"db064466","266":"3f65cab1","341":"06439378","368":"6ad4b3e5","451":"533c32a1","507":"d4c0949f","554":"1ab6e6b8","645":"0cd5b476","660":"52d62388","667":"49b33ea1","691":"9569af43","692":"b758b244","752":"e465cfcc","766":"8e0527bf"}[chunkId] + ".chunk.js";
};